import ImageManagement from './ImageManagement';

export default ImageManagement;
